import mapCurrencyFromApi from 'rtkQuery/sharespro/mapper/shared/mapCurrencyFromApi';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';

export const mapOperationItemFromApi = (
  apiItem: ApiOperationListItem
): OperationListItem => {
  return {
    name: apiItem.title,
    date: new Date(apiItem.date * 1000),
    amount: apiItem.sum,
    currency: mapCurrencyFromApi(apiItem.currency),
    assetType: apiItem.asset_type,
    quantity: apiItem.quantity,
    info: apiItem.info,
    direction: apiItem.direction,
  };
};

const mapOperationListFromApi = (
  resp: SharesproApiResponse<ApiOperationsResponse>
): PaginationList<OperationListItem> => {
  return mapPaginationListFromApi<OperationListItem, ApiOperationListItem>(
    resp.data.events,
    mapOperationItemFromApi
  );
};

export default mapOperationListFromApi;
